
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '~/store/modules/user';

@Component({})
export default class deleteIdentityKeys extends Vue {
    isDialogOpen = false;

    async deleteIdentityKeys(): Promise<void> {
        await UserModule.deleteIdentityKeys();
        this.isDialogOpen = false;
    }

    get userMail(): string {
        return UserModule.userMail;
    }
}
